import React, { Component } from "react";
import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import FilterListIcon from "@material-ui/icons/FilterList";
import MenuItem from "@material-ui/core/MenuItem";

export default class EnhancedTableToolbar extends Component {
	classes = {
		highlight: "makeStyles-highlight-196",
		root: "makeStyles-root-195",
		title: "makeStyles-title-197"
	};

	state = {
		meetingType: "",
		open: false
	};

	handleChange = event => {
		this.setState(
			{
				meetingType: event.target.value
			},
			() => {
				this.props.handleMeetingType(this.state.meetingType);
			}
		);
	};

	handleClose = () => {
		this.setState({
			open: false
		});
	};

	handleOpen = () => {
		this.setState({
			open: true
		});
	};

	render() {
		return (
			<Toolbar
				className={clsx(this.classes.root, {
					[this.classes.highlight]: this.props.numSelected > 0
				})}
				style={{
					display: "flex",
					justifyContent: "space-between",
					paddingLeft: 17,
					paddingRight: 12
				}}
			>
				<Typography className={this.classes.title} variant="h6" id="tableTitle">
					{this.state.meetingType === "current"
						? "Current Meetings"
						: this.state.meetingType === "upcoming"
						? "Upcoming Meetings"
						: this.state.meetingType === "previous"
						? "Previous Meetings"
						: "All Meetings"}
				</Typography>
				<div>
					<Tooltip title="Filter meeting">
						<IconButton aria-label="filter meeting" onClick={this.handleOpen}>
							<FilterListIcon />
						</IconButton>
					</Tooltip>
					<Select
						open={this.state.open}
						onClose={this.handleClose}
						onOpen={this.handleOpen}
						value={this.state.meetingType}
						onChange={this.handleChange}
						style={{ height: 0, width: 0, opacity: 0, right: 100 }}
					>
						<MenuItem value="all">All</MenuItem>
						<MenuItem value="current">Current</MenuItem>
						<MenuItem value="upcoming">Upcoming</MenuItem>
						<MenuItem value="previous">Previous</MenuItem>
					</Select>
				</div>
			</Toolbar>
		);
	}
}
